import React from "react";
import TahkimSurukleBirakTahta from "./TahkimSurukleBirakTahta";

export default function TahkimKanban({ columns, onRefresh, loading }) {
    return (
        <TahkimSurukleBirakTahta
            columns={columns}
            loading={loading}
            onRefresh={onRefresh}
            baslik="Kanban — tüm aşamalar sürükle-bırak"
            aciklama="Ön Tahkim’den Kapandı’ya kadar her kolona kart sürükleyin. Geçiş penceresinde Tahkim Veri Girişi alanlarını (başvuru no, hakem, bilirkişi, ödeme vb.) doldurabilirsiniz."
        />
    );
}
